import {
    Directive,
    ElementRef,
    EventEmitter,
    Input,
    Output,
    Renderer2
} from '@angular/core';

@Directive({
    selector: '[uppercase]',
    host: {
        '(uppercase)': 'format($event)'
    }
})
export class UpperCaseText {
    @Input() uppercase: string;
    @Output() uppercaseChange: EventEmitter<string> = new EventEmitter<string>();

    constructor(private ref: ElementRef, private renderer: Renderer2) {
    }

    format($event) {
        const value =  $event.target.value || '';
        this.ref.nativeElement.value = value.toUpperCase();

    }
}
